<template>
  <div>
    <Title :pages="[{ icon: 'clipboard-check', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <div class="content-main">
        <Modal
          v-if="create_access"
          :button_name="'Crear ' + modal_title"
          :modal_title="modal_title"
          :page_title="page_title"
          :formBtn="formBtn"
          :dialog="dialog"
          :service="service"
          @updateDialog="updateDialog"
          @loadList="loadList(service)"
          :editItem="mainItem"
        />

        <!-- Filtros -->
        <v-card class="mb-4" v-if="list_access">
          <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
            <div class="col-md-12">
              <div class="col-md-12" style="background: white">
                <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
                <v-divider class="mt-0"></v-divider>

                <div class="row pt-2">
                  <div class="col-md-3">
                    <v-text-field v-model="filters.date_from" density="comfortable" type="date" label="Desde" clearable></v-text-field>
                  </div>
                  <div class="col-md-3">
                    <v-text-field v-model="filters.date_to" density="comfortable" type="date" label="Hasta" clearable></v-text-field>
                  </div>
                  <div class="col-md-3">
                    <v-select v-model="filters.date_type" density="comfortable" item-title="name" item-value="id" :items="date_types" label="Filtrar por fecha de" return-object></v-select>
                  </div>
                  <div class="col-md-3">
                    <v-text-field v-model="filters.id" density="comfortable" label="Nro. de conteo" autocomplete="off" clearable @keyup.enter="filter"></v-text-field>
                  </div>
                  <div class="col-md-3">
                    <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacén" autocomplete="off" clearable></v-combobox>
                  </div>
                  <div class="col-md-3">
                    <v-combobox v-model="filters.status" density="comfortable" item-title="name" item-value="id" :items="states" label="Estado" autocomplete="off" clearable></v-combobox>
                  </div>
                  <div class="col-md-3">
                    <v-combobox v-model="filters.type" density="comfortable" item-title="name" item-value="id" :items="types" label="Tipo" autocomplete="off" clearable></v-combobox>
                  </div>
                  <div class="col-md-3 d-flex align-center">
                    <v-checkbox v-model="filters.only_abiertos" label="Solo conteos abiertos" hide-details density="compact"></v-checkbox>
                  </div>

                  <div class="col-md-12 pt-2" style="display: flex; justify-content: end; align-items: center">
                    <v-btn color="info" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>

        <!-- Tabla -->
        <v-card v-if="list_access">
          <v-card-title>
            <v-row align="center" class="mt-1">
              <v-col>
                <span>{{ page_title }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" md="3">
                <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table :items-per-page="0" :hide-default-footer="true" :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
            <template v-slot:item="{ item }">
              <tr>
                <td>#{{ item.id }}</td>
                <td>{{ item.type ? item.type.name : "-" }}</td>
                <td>{{ item.almacen ? item.almacen.name : "-" }}</td>
                <td>{{ item.client ? item.client.name : "Todos" }}</td>
                <td>{{ item.scheduled_date ? item.scheduled_date : "-" }}</td>
                <td>{{ item.creation_date }}</td>
                <td>
                  <div class="status-badge font-weight-medium" :class="service.getStatusClass(item.status ? item.status.id : null)">
                    {{ item.status ? item.status.name : "-" }}
                  </div>
                </td>
                <td class="text-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" small color="blue" class="mr-2" @click="verDetalle(item)" size="small">mdi-eye</v-icon>
                    </template>
                    <span>Ver seguimiento y diferencias</span>
                  </v-tooltip>

                  <!-- Editar (incluye la seleccion de ubicaciones, en el step 2): solo en borrador -->
                  <v-tooltip bottom v-if="update_access && service.isEditable(item.status ? item.status.id : null)">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" small color="blue" class="mr-2" @click="editItem(item)" size="small">mdi-pencil</v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="update_access && service.isEditable(item.status ? item.status.id : null)">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" small color="green" class="mr-2" @click="confirmarEmitir(item)" size="small">mdi-send</v-icon>
                    </template>
                    <span>Emitir: bloquea las ubicaciones y emite las tareas</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="update_access && service.canCerrar(item.status ? item.status.id : null)">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" small color="red" class="mr-2" @click="confirmarCerrar(item)" size="small">mdi-door</v-icon>
                    </template>
                    <span>Cerrar el conteo</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="update_access && service.isAbierto(item.status ? item.status.id : null)">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" small color="orange" class="mr-2" @click="confirmarCancelar(item)" size="small">mdi-cancel</v-icon>
                    </template>
                    <span>Cancelar: desbloquea todo y no aplica ningún ajuste</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="delete_access && service.isEditable(item.status ? item.status.id : null)">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" small color="red" class="mr-2" @click="deleteItem(item)" size="small">mdi-delete</v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>

        <div class="text-right mt-2" v-if="list_access">
          <small class="text-grey">
            {{ paginationText }}
          </small>
        </div>
        <v-pagination
          v-if="list_access && cant_pages > 1"
          v-model="current_page"
          :length="cant_pages"
          total-visible="10"
          @update:modelValue="loadPage(service)"
          class="mt-4"
        ></v-pagination>

        <DialogYesNo
          :open="dialog_confirm"
          :title="confirm_title"
          :message="confirm_message"
          :loading="loadingSubmit"
          @cancel="dialog_confirm = false"
          @accept="ejecutarAccion"
        />

        <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />
      </div>
    </v-container>
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";
import { conteoService } from "@/libs/ws/conteoService";
import { almacenService } from "@/libs/ws/almacenService";
import Constant from "@/constants/sections";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./Modal.vue";

export default {
  components: { Title, Modal, DialogDelete, DialogYesNo },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      rol_section: Constant.SECTION_CONTEO,
      service: conteoService,
      page_title: "Conteo cíclico",
      modal_title: "Conteo",

      almacenes: [],
      states: [],
      types: [],
      date_types: [
        { id: "creation_date", name: "Creación" },
        { id: "scheduled_date", name: "Planificada" },
      ],

      //Emitir / cancelar / cerrar comparten el mismo dialogo de confirmacion: los tres son
      //irreversibles y los tres tienen que decir QUE le hacen al stock antes de dispararse.
      dialog_confirm: false,
      confirm_title: "",
      confirm_message: "",
      accion_pendiente: null,
      accion_item: null,

      filters: {
        id: "",
        almacen: null,
        status: null,
        type: null,
        only_abiertos: false,
        date_type: { id: "creation_date", name: "Creación" },
        date_from: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
      },
      headers: [
        { title: "Nro.", align: "left", sortable: true, key: "id" },
        { title: "Tipo", align: "left", sortable: true, key: "type.name" },
        { title: "Almacén", align: "left", sortable: true, key: "almacen.name" },
        { title: "Cliente", align: "left", sortable: true, key: "client.name" },
        { title: "Fecha planificada", align: "left", sortable: true, key: "scheduled_date" },
        { title: "Creación", align: "left", sortable: true, key: "creation_date" },
        { title: "Estado", align: "left", sortable: true, key: "status.name" },
        { title: "Acción", align: "center", sortable: false, key: "" },
      ],
    };
  },
  mounted() {
    this.loadAlmacenes();
    this.loadStates();
    this.loadTypes();
    this.loadList(this.service);
  },
  methods: {
    getFilterParams() {
      var param = {};
      if (this.filters.id) param.id = this.filters.id;
      if (this.filters.almacen && this.filters.almacen.id) param.almacen = { id: this.filters.almacen.id };
      if (this.filters.status && this.filters.status.id) param.status = { id: this.filters.status.id };
      if (this.filters.type && this.filters.type.id) param.type = { id: this.filters.type.id };
      if (this.filters.only_abiertos) param.only_abiertos = true;
      //El backend filtra creation_date_from/to o scheduled_date_from/to segun el tipo elegido
      const date_type = this.filters.date_type ? this.filters.date_type.id : "creation_date";
      if (this.filters.date_from) param[date_type + "_from"] = this.filters.date_from;
      if (this.filters.date_to) param[date_type + "_to"] = this.filters.date_to;
      return param;
    },
    filter() {
      this.current_page = 1;
      this.loadList(this.service);
    },
    loadAlmacenes() {
      almacenService.filter({}).then((response) => {
        if (response.status) this.almacenes = response.result.list;
      });
    },
    loadStates() {
      this.service.list_states().then((response) => {
        if (response.status) this.states = response.result.list;
      });
    },
    loadTypes() {
      this.service.list_types().then((response) => {
        if (response.status) this.types = response.result.list;
      });
    },
    verDetalle(item) {
      this.$router.push("/" + Constant.SECTION_CONTEO + "/" + item.id);
    },

    // --- Transiciones
    confirmarEmitir(item) {
      this.accion_pendiente = "emitir";
      this.accion_item = item;
      this.confirm_title = "Emitir el conteo #" + item.id;
      this.confirm_message =
        "Se congela el stock teórico de cada ubicación, se bloquean las ubicaciones (no se van a poder pickear, guardar ni transferir) y se emiten las tareas de conteo. No se puede volver a borrador.";
      this.dialog_confirm = true;
    },
    confirmarCancelar(item) {
      this.accion_pendiente = "cancel";
      this.accion_item = item;
      this.confirm_title = "Cancelar el conteo #" + item.id;
      this.confirm_message = "Se desbloquean todas las ubicaciones, se dan de baja las tareas pendientes y NO se aplica ningún ajuste: lo contado se descarta.";
      this.dialog_confirm = true;
    },
    confirmarCerrar(item) {
      this.accion_pendiente = "cerrar";
      this.accion_item = item;
      this.confirm_title = "Cerrar el conteo #" + item.id;
      this.confirm_message = "Se desbloquean las ubicaciones y el documento queda sellado. Solo se puede cerrar si no quedan ubicaciones sin contar ni diferencias sin resolver.";
      this.dialog_confirm = true;
    },
    ejecutarAccion() {
      if (this.accion_pendiente == null || this.accion_item == null) return;

      this.loadingSubmit = true;
      this.service[this.accion_pendiente]({ id: this.accion_item.id })
        .then((response) => {
          if (response.status) {
            this.toast.success(response.msg);
            this.loadList(this.service);
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch(() => {
          this.toast.error("Error al ejecutar la acción.");
        })
        .finally(() => {
          this.loadingSubmit = false;
          this.dialog_confirm = false;
          this.accion_pendiente = null;
          this.accion_item = null;
        });
    },
  },
};
</script>
